<template>
  <div :class="{ backgray: $route.path == '/conta/meus-planos' }">
    <app-header v-if="showMenu"></app-header>

    <!--
       WEBVIEW NÃO DETECTA UNIDADES DE MEDIDAS VH (height: 100vh) PARA PEGAR A ALTURA TOTAL DO
       DEVICE: window.screen.height // window.inerHeight
     -->
    <section
      :style="
        window.document.webview ? `min-height: ${window.screen.height}px` : ''
      "
      class="outside-section"
      :class="{
        section:
          !showMenu &&
          $route.path != '/vale-pedagio' &&
          $route.path != '/valepedagio',
      }"
    >
      <router-view></router-view>
    </section>

    <div id="footer" v-if="showMenu">
      <app-footer></app-footer>
    </div>

    <message-dialog></message-dialog>

    <div id="loading-box-100" v-show="isLoading">
      <div id="loading-box-content-100">
        <svg class="loading-draw-svg" :viewBox="markViewBox" xmlns="http://www.w3.org/2000/svg">
          <path class="loading-draw-path" fill-rule="evenodd" clip-rule="evenodd" :d="markPath"/>
        </svg>
      </div>
    </div>
  </div>
</template>
<style>
@media (max-width: 991px) {
  .backgray {
    background-color: #dee6e6;
  }
}
</style>
<script>
import AppHeader from "./app-header.vue";
import AppFooter from "./app-footer.vue";
import MessageDialog from "../components/message-dialog.vue";
import { MOVE_MAIS_MARK_PATH, MOVE_MAIS_MARK_VIEWBOX } from "../assets/brand-mark.js";

export default {
  data() {
    return {
      showMenu: true,
      isMobile: false,
      interfaces: ["WEBSITE", "MOBILE"],
      markPath: MOVE_MAIS_MARK_PATH,
      markViewBox: MOVE_MAIS_MARK_VIEWBOX,
    };
  },
  beforeMount() {
    // Verificar se a palavra "hotsite" está presente na URL
    if (window.location.href.includes("hotsite")) {
      this.showMenu = false;
    }

  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("/conta/") == 0 || to.path.indexOf("/hotsite") == 0) {
        this.showMenu = false;
      } else {
        this.showMenu = true;
      }
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading;
    },
    ios() {
      return window.document.ios;
    },
  },
  created() {
    if (this.$route.path.indexOf("/conta/") == 0) {
      this.showMenu = false;
    }
    // Detecta o user-agent e coloca classe correspondento no document
    (function (d, l) {
      for (var k in l) {
        if (navigator.userAgent.match(new RegExp(l[k], "i"))) {
          d[k] = true;
          d.documentElement.className += " " + k;
        }
      }
    })(document, {
      ios: "(iPhone|iPod|iPad|Macintosh)",
      android: "android",
      mobile: "mobile",
      webview: "((iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)|webview)",
    });
  },
  mounted() {
    let promise = this.$store.dispatch("getPlans").catch((err) => {
      MessageDialog.show({
        title: "Erro",
        message:
          "Houve um problema ao carregar as informações do plano, provavelmente devido a uma falha de conexão, vamos tentar recarregar a página",
      }).then((r) => {
        location.reload(true);
      });
    });

    if (this.$route.query.promotionCode) {
      sessionStorage.setItem("promotionCode", this.$route.query.promotionCode);
    }
    //Configura a promoção vigente
    //this.$store.dispatch('getPromotionCode','MAE50').then(()=>
  },

  methods: {
  },
  components: {
    AppHeader,
    AppFooter,
    MessageDialog,
  },
};
</script>



// WEBPACK FOOTER //
// app.vue?62a96fa0